module.exports = __webpack_public_path__ + "img/Icon material-done.5d78359e.svg";